"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftMatchSummaryDto = instanceOfShiftMatchSummaryDto;
exports.ShiftMatchSummaryDtoFromJSON = ShiftMatchSummaryDtoFromJSON;
exports.ShiftMatchSummaryDtoFromJSONTyped = ShiftMatchSummaryDtoFromJSONTyped;
exports.ShiftMatchSummaryDtoToJSON = ShiftMatchSummaryDtoToJSON;
exports.ShiftMatchSummaryDtoToJSONTyped = ShiftMatchSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftMatchSummaryDto interface.
 */
function instanceOfShiftMatchSummaryDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    return true;
}
function ShiftMatchSummaryDtoFromJSON(json) {
    return ShiftMatchSummaryDtoFromJSONTyped(json, false);
}
function ShiftMatchSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'id': json['id'] == null ? undefined : json['id'],
        'avatar': json['avatar'],
    };
}
function ShiftMatchSummaryDtoToJSON(json) {
    return ShiftMatchSummaryDtoToJSONTyped(json, false);
}
function ShiftMatchSummaryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'id': value['id'],
        'avatar': value['avatar'],
    };
}
//# sourceMappingURL=ShiftMatchSummaryDto.js.map